import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯", to: "/news" },
  { label: "电影大全", to: "/category/movie" },
  { label: "剧集推荐", to: "/category/tvshow" },
  { label: "综艺频道", to: "/category/show" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-secondary-900/10 bg-secondary-950 text-background-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8 md:py-14">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg" />
            </span>
            <span className="font-heading text-lg font-black tracking-tight text-background-50">
              91蜜桃
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/70">
            91蜜桃致力于为用户提供丰富的最新影视资源，涵盖电影、电视剧、综艺与影视资讯，
            方便影迷快速查找、浏览和了解影视作品。本站仅提供作品资料与资讯展示，不提供在线播放与下载。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-100">
              <i className="ri-wechat-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-100">
              <i className="ri-weibo-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-100">
              <i className="ri-mail-line" />
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-background-50">友情链接</h3>
          <ul className="mt-4 space-y-2.5">
            {friendLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background-200/70 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200/70">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-primary-300" />
              hi@91peach.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-base text-primary-300" />
              400-000-9191
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-base text-primary-300" />
              北京市朝阳区影视产业园
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-200/60 sm:flex-row md:px-8">
          <p>© 91蜜桃 保留所有权利</p>
          <p className="flex items-center gap-4">
            <span>本站内容仅供学习交流，不提供播放与下载</span>
            <span className="hidden sm:inline">·</span>
            <span>京ICP备0000000号</span>
          </p>
        </div>
      </div>
    </footer>
  );
}